import { useStep } from '@raskrask-dk/rr-components'
import { Helpers } from '@raskrask-dk/rr-components/lib/Hooks/useStep'
import React from 'react'
import { ReactElement } from 'react'

const ContextSteps = React.createContext<[number, Helpers] | undefined>(
    undefined
)

const ProviderSteps = ({
    children,
}: {
    children: ReactElement | ReactElement[]
}): ReactElement => {
    const [currentStep, helpers] = useStep(7)

    return (
        <ContextSteps.Provider value={[currentStep, helpers]}>
            {children}
        </ContextSteps.Provider>
    )
}

const useSteps = (): [number, Helpers] => {
    const useSteps = React.useContext(ContextSteps)
    if (!useSteps)
        throw new Error('useSteps must be accessed through ProviderStep')
    return useSteps
}

export { ContextSteps, ProviderSteps, useSteps }
